import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://pro-dash.orima.ma/api/v1';

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    timeout: 30000, // ✅ Increased timeout to 30 seconds
});

// Error interceptor
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.code === 'ECONNABORTED') {
            console.error('Request timeout');
        } else if (error.message === 'Network Error') {
            console.error('Network Error - Check Laravel server');
        }
        return Promise.reject(error);
    }
);

// Product Services
export const productService = {
    getProducts: async (params) => {
        const response = await apiClient.get('/products', { params });
        return response.data;
    },
    getFeaturedProducts: async () => {
        const response = await apiClient.get('/products/featured');
        return response.data;
    },
    getProduct: async (id) => {
        const response = await apiClient.get(`/products/${id}`);
        return response.data;
    },
};

// Category Services
export const categoryService = {
    getCategories: async () => {
        const response = await apiClient.get('/categories');
        return response.data;
    },
    getCategoryProducts: async (id) => {
        const response = await apiClient.get(`/categories/${id}/products`);
        return response.data;
    },
};

// Delivery Services
export const deliveryService = {
    getDeliveryCompanies: async () => {
        const response = await apiClient.get('/delivery-companies');
        return response.data;
    },
};

// Order Services
export const orderService = {
    createOrder: async (orderData) => {
        console.log('🚀 Sending to API:', orderData);
        const response = await apiClient.post('/orders', orderData);
        return response.data;
    },
    getOrder: async (orderNumber) => {
        const response = await apiClient.get(`/orders/${orderNumber}`);
        return response.data;
    },
    trackOrder: async (orderNumber) => {
        const response = await apiClient.get(`/orders/track/${orderNumber}`);
        return response.data;
    },
};

export default apiClient;
